import type { PendingShopifyApprovalInfo } from "@intelligems/ig-types";

import type { BillingStatusContent } from "./useBillingStatusContent";

export const shouldSuppressShopifyApprovalNudge = (
  actionType: BillingStatusContent["actionType"],
  search: string
): boolean =>
  actionType === "shopify-approval" &&
  new URLSearchParams(search).has("charge_id");

export const getShopifyApprovalRedirectId = (
  pendingApproval: PendingShopifyApprovalInfo | undefined
): string | undefined => {
  if (!pendingApproval) {
    return undefined;
  }

  if ("approvalId" in pendingApproval) {
    return pendingApproval.confirmationRedirectAvailable
      ? pendingApproval.approvalId
      : undefined;
  }

  return pendingApproval.commandId;
};
